import comp from "./SearchInput";
export default comp;
